/* ==========================================================================
   VAULT theme — global.js (clean rebuild)
   One unified add-to-cart pipeline. Every trigger (main button, mobile
   sticky bar, variant bottom sheet) calls the same addToCart() and gets
   the identical success flow: button state → cart bump → toast.
   ========================================================================== */
(function () {
  'use strict';
  window.VAULT_VERSION = '1.9-unified-pipeline';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ *
   * 1. Header: glass on scroll + mobile menu
   * ------------------------------------------------------------------ */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.header-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------------------------ *
   * 2. Reveal on scroll
   * ------------------------------------------------------------------ */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ------------------------------------------------------------------ *
   * 3. Signature: code scramble
   * ------------------------------------------------------------------ */
  var CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
  function scramble(el) {
    var target = el.getAttribute('data-code') || el.textContent.trim();
    var frame = 0, total = 34;
    var timer = setInterval(function () {
      var out = '';
      for (var i = 0; i < target.length; i++) {
        var ch = target[i];
        if (ch === '-' || ch === ' ') { out += ch; continue; }
        var settle = (i / target.length) * total * 0.7;
        out += frame > settle
          ? '<span class="lit">' + ch + '</span>'
          : CHARS[Math.floor(Math.random() * CHARS.length)];
      }
      el.innerHTML = out;
      if (++frame > total) clearInterval(timer);
    }, 42);
  }
  document.querySelectorAll('[data-code]').forEach(function (el) {
    if (reduceMotion) {
      el.innerHTML = '<span class="lit">' + (el.getAttribute('data-code') || '') + '</span>';
      return;
    }
    if ('IntersectionObserver' in window) {
      var seen = false;
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !seen) { seen = true; scramble(el); io2.unobserve(el); }
        });
      }, { threshold: 0.4 });
      io2.observe(el);
    } else {
      scramble(el);
    }
  });

  /* ------------------------------------------------------------------ *
   * 4. Magnetic primary buttons (desktop, motion-safe)
   * ------------------------------------------------------------------ */
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  if (!reduceMotion && !coarse) {
    document.querySelectorAll('.btn-primary').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 8;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 6;
        btn.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ------------------------------------------------------------------ *
   * 5. Product page
   * ------------------------------------------------------------------ */
  var form = document.querySelector('[data-product-form]');
  if (!form) return; /* everything below only runs on product pages */

  var stringsEl = document.getElementById('VaultStrings');
  var STR = stringsEl ? JSON.parse(stringsEl.textContent) : {};
  var dataEl = document.getElementById('ProductVariantData');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var idInput = form.querySelector('[name="id"]');
  var mainBtn = form.querySelector('[data-buy-button]');
  var stickyBar = document.querySelector('.sticky-cta');
  var stickyBtn = document.querySelector('[data-sticky-add]');
  var sheet = document.querySelector('.variant-sheet');
  var backdrop = document.querySelector('.sheet-backdrop');
  var buyCard = document.querySelector('.buy-card');

  /* --- 5a. Money + variant sync (price / availability) ---------------- */
  function money(cents) {
    var el = document.getElementById('ProductMoneyFormat');
    var fmt = el ? el.textContent : '{{amount}}';
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
  }
  function currentSelection() {
    var opts = [];
    form.querySelectorAll('.variant-fieldset').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }
  function syncVariant() {
    var sel = currentSelection();
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    var priceHtml = money(match.price);
    if (match.compare_at_price && match.compare_at_price > match.price) {
      priceHtml = '<s>' + money(match.compare_at_price) + '</s><span class="sale">' + money(match.price) + '</span>';
    }
    var priceEl = document.querySelector('[data-product-price]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');
    if (priceEl) priceEl.innerHTML = priceHtml;
    if (stickyPriceEl) stickyPriceEl.innerHTML = priceHtml;
    [mainBtn, stickyBtn].forEach(function (b) {
      if (!b || b.classList.contains('is-loading')) return;
      b.disabled = !match.available;
      if (b === mainBtn) {
        b.textContent = match.available
          ? (b.getAttribute('data-label-buy') || b.textContent)
          : (b.getAttribute('data-label-soldout') || b.textContent);
      }
    });
  }
  if (form.querySelector('.variant-fieldset')) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('.variant-fieldset input')) syncVariant();
    });
    syncVariant();
  }

  /* --- 5b. Sticky bar visibility -------------------------------------- */
  if (stickyBar && buyCard && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(buyCard);
  }
  var footer = document.querySelector('.site-footer');
  if (stickyBar && footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-hidden', entries[0].isIntersecting);
    }, { threshold: 0 }).observe(footer);
  }

  /* --- 5c. Description iframes: lazy ---------------------------------- */
  document.querySelectorAll('.product-desc iframe').forEach(function (fr) {
    fr.setAttribute('loading', 'lazy');
  });

  /* --- 5d. Toast system ------------------------------------------------ */
  var stack = document.createElement('div');
  stack.className = 'toast-stack';
  stack.setAttribute('aria-live', 'polite');
  document.body.appendChild(stack);

  function showToast(title, sub, isError) {
    var visible = stickyBar && stickyBar.classList.contains('is-visible') && !stickyBar.classList.contains('is-hidden');
    stack.classList.toggle('raised', !!visible);
    var toast = document.createElement('div');
    toast.className = 'toast ' + (isError ? 'toast--error' : 'toast--success');
    toast.innerHTML =
      '<span class="toast-check">' + (isError ? '!' : '✓') + '</span>' +
      '<div class="toast-body"><strong></strong>' + (sub ? '<span></span>' : '') + '</div>' +
      (isError ? '' : '<a href="/cart">' + (STR.view_cart || 'View cart') + '</a>');
    toast.querySelector('strong').textContent = title;
    if (sub) toast.querySelector('.toast-body span').textContent = sub;
    stack.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('in'); });
    setTimeout(function () {
      toast.classList.remove('in');
      toast.classList.add('out');
      setTimeout(function () { toast.remove(); }, 450);
    }, 2800);
  }

  /* --- 5e. Header cart bump -------------------------------------------- */
  function bumpCart(newCount) {
    document.querySelectorAll('.header-cart').forEach(function (el) {
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.classList.add('pop');
      setTimeout(function () {
        if (newCount !== undefined) el.textContent = newCount;
        el.classList.remove('pop');
      }, reduceMotion ? 0 : 160);
    });
  }

  /* --- 5f. Button states ------------------------------------------------ */
  function setLoading(btn) {
    btn.dataset.restore = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span>' + (STR.adding || 'Adding') + '…';
  }
  function setSuccess(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    btn.innerHTML = '<span class="btn-tick" aria-hidden="true">✓</span>' + (STR.added || 'Added to cart');
  }
  function setError(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-error');
    btn.innerHTML = STR.error || "Couldn't add — try again";
  }
  function resetBtn(btn, delay) {
    setTimeout(function () {
      btn.classList.remove('is-loading', 'is-success', 'is-error');
      btn.removeAttribute('aria-busy');
      btn.innerHTML = btn.dataset.restore || btn.innerHTML;
      btn.disabled = false;
    }, delay);
  }

  /* ==================================================================== *
   * 5g. THE unified add-to-cart pipeline.
   * Every trigger routes here. variantId is optional (the sheet passes
   * one); triggers is the list of buttons that should animate.
   * Returns a promise resolving true on success.
   * ==================================================================== */
  var busy = false;
  function addToCart(variantId, triggers) {
    if (busy) return Promise.resolve(false);
    busy = true;

    if (variantId && idInput) idInput.value = variantId;

    var targets = [];
    (triggers || []).concat(mainBtn ? [mainBtn] : []).forEach(function (b) {
      if (b && targets.indexOf(b) === -1) targets.push(b);
    });
    targets.forEach(setLoading);
    var started = Date.now();

    return fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (item) {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
          .then(function (cart) {
            /* keep the loading state readable: 350ms minimum */
            var wait = Math.max(0, 350 - (Date.now() - started));
            return new Promise(function (resolve) {
              setTimeout(function () {
                var title = item.product_title +
                  (item.variant_title && item.variant_title !== 'Default Title'
                    ? ' — ' + item.variant_title : '');
                targets.forEach(function (t) { setSuccess(t); resetBtn(t, 1700); });
                bumpCart(cart ? cart.item_count : undefined);
                showToast(title, STR.in_cart || 'successfully added to your cart', false);
                busy = false;
                resolve(true);
              }, wait);
            });
          });
      })
      .catch(function () {
        targets.forEach(function (t) { setError(t); resetBtn(t, 2200); });
        showToast(STR.error || "Couldn't add — try again", '', true);
        busy = false;
        return false;
      });
  }

  /* --- Trigger 1: standard product form -------------------------------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (mainBtn && mainBtn.disabled && !mainBtn.classList.contains('is-loading')) return;
    addToCart(null, [mainBtn]);
  });

  /* --- Variant bottom sheet --------------------------------------------- */
  function openSheet() {
    if (!sheet || !backdrop) return;
    var formId = idInput ? idInput.value : null;
    if (formId) {
      var match = sheet.querySelector('input[value="' + formId + '"]');
      if (match && !match.disabled) match.checked = true;
    }
    sheet.hidden = false; backdrop.hidden = false;
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.classList.add('sheet-open');
    });
  }
  function closeSheet() {
    if (!sheet || !backdrop) return;
    sheet.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('sheet-open');
    setTimeout(function () { sheet.hidden = true; backdrop.hidden = true; }, 460);
  }
  if (sheet && backdrop) {
    document.querySelectorAll('[data-sheet-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) closeSheet();
    });

    /* also mirror the sheet choice back into the main form's radios */
    sheet.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="sheet-variant"]')) return;
      var v = variants.find(function (x) { return String(x.id) === e.target.value; });
      if (!v) return;
      v.options.forEach(function (optValue, i) {
        var fs = form.querySelectorAll('.variant-fieldset')[i];
        if (!fs) return;
        var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (inp) {
          return inp.value === optValue;
        });
        if (input) input.checked = true;
      });
      syncVariant();
    });

    /* --- Trigger 2: sheet Add button — same pipeline ------------------- */
    var sheetAdd = sheet.querySelector('[data-sheet-add]');
    if (sheetAdd) {
      sheetAdd.addEventListener('click', function () {
        var chosen = sheet.querySelector('input[name="sheet-variant"]:checked');
        if (!chosen) return;
        addToCart(chosen.value, [sheetAdd, stickyBtn]).then(function (ok) {
          if (ok) setTimeout(closeSheet, 350);
        });
      });
    }
  }

  /* --- Trigger 3: mobile sticky bar -------------------------------------- */
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (sheet) { openSheet(); return; }   /* multi-variant: choose first  */
      addToCart(null, [stickyBtn]);         /* single variant: same pipeline */
    });
  }
})();

/* Cart page: quantities apply themselves — no "Update cart" button needed */
(function () {
  'use strict';
  var cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm) return;
  var timer = null;
  cartForm.addEventListener('change', function (e) {
    if (!e.target.matches('.qty-input')) return;
    var line = e.target.closest('.cart-line');
    if (line) line.classList.add('is-updating');
    clearTimeout(timer);
    timer = setTimeout(function () { cartForm.submit(); }, 350); /* debounce rapid +/- taps */
  });
})();
